import React, { useEffect, useState, useRef } from 'react';
import { User, Settings, HelpCircle, LogOut, CreditCard, Bell } from 'lucide-react';
type ProfileDropdownProps = {
  isOpen: boolean;
  onClose: () => void;
  onNavigate: (page: string) => void;
  anchorRef: React.RefObject<HTMLElement>;
};
export function ProfileDropdown({
  isOpen,
  onClose,
  onNavigate,
  anchorRef
}: ProfileDropdownProps) {
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node) && anchorRef.current && !anchorRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose, anchorRef]);
  if (!isOpen) return null;
  const menuItems = [{
    id: 'profile',
    label: 'Profile',
    icon: User
  }, {
    id: 'settings',
    label: 'Settings',
    icon: Settings
  }, {
    id: 'billing',
    label: 'Billing',
    icon: CreditCard
  }, {
    id: 'notifications',
    label: 'Notifications',
    icon: Bell
  }, {
    id: 'help',
    label: 'Help & Support',
    icon: HelpCircle
  }];
  return <div ref={dropdownRef} className="absolute bottom-full left-4 mb-2 w-56 bg-white rounded-xl shadow-lg border border-gray-200 py-2 animate-scale-in z-50" data-id="element-1409">
      {/* User Info */}
      <div className="px-4 py-3 border-b border-gray-100" data-id="element-1410">
        <div className="font-semibold text-gray-900" data-id="element-1411">Daniel</div>
        <div className="text-sm text-gray-600" data-id="element-1412">daniel@example.com</div>
      </div>

      {/* Menu Items */}
      <div className="py-2" data-id="element-1413">
        {menuItems.map(item => {
        const Icon = item.icon;
        return <button key={item.id} onClick={() => {
          onNavigate(item.id);
          onClose();
        }} className="w-full flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 transition-colors text-left" data-id="element-1414">
              <Icon className="w-4 h-4 text-gray-600" data-id="element-1415" />
              <span className="text-sm text-gray-900" data-id="element-1416">{item.label}</span>
            </button>;
      })}
      </div>

      {/* Logout */}
      <div className="border-t border-gray-100 pt-2" data-id="element-1417">
        <button onClick={() => {
        console.log('Logout');
        onClose();
      }} className="w-full flex items-center gap-3 px-4 py-2.5 hover:bg-red-50 transition-colors text-left text-red-600" data-id="element-1418">
          <LogOut className="w-4 h-4" data-id="element-1419" />
          <span className="text-sm font-medium" data-id="element-1420">Log out</span>
        </button>
      </div>
    </div>;
}